import { ShopSelection } from "@/components/Filter/shopSelection";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import _ from "lodash";

export default function TargetRow(props) {
  const {
    index,
    shopTarget,
    shopOptions,
    setShopTarget,
    handleRemoveRow,
    selectedShop,
    disabled,
    viewOnly = false,
  } = props;
  return (
    <Grid size={12} container key={index} spacing={2}>
      <Grid size={3}>
        <TextField
          disabled={disabled}
          id="target_shop_name"
          name="target_shop_name"
          label={`名稱`}
          fullWidth
          value={shopTarget.target_shop_name}
          onChange={(event) => {
            setShopTarget(index, "target_shop_name", event.target.value);
          }}
        />
      </Grid>
      {viewOnly ? (
        <Grid size={6}>
          <Autocomplete
            fullWidth
            multiple
            id="店鋪"
            value={_.filter(shopOptions, (shopOption) =>
              _.includes(shopTarget.shop, shopOption.shop_id)
            )}
            isOptionEqualToValue={(option, value) => option === value.shop_id}
            disabled
            options={shopOptions}
            getOptionLabel={(option) =>
              `${option.work_name}(${option.work_shortcode})`
            }
            renderInput={(params) => (
              <TextField {...params} label="店鋪" placeholder="店鋪" />
            )}
          />
        </Grid>
      ) : (
        <Grid size={3}>
          <ShopSelection
            disabled={disabled}
            filter={shopTarget}
            selectedShop={selectedShop}
            handleShopFilterChange={(value) => {
              setShopTarget(index, "shop", value);
            }}
            shopOptions={shopOptions}
          ></ShopSelection>
        </Grid>
      )}
      <Grid size={3}>
        <TextField
          disabled={disabled}
          id="target_amount"
          name="target_amount"
          label="目標量"
          fullWidth
          value={shopTarget.target_amount}
          onChange={(event) => {
            setShopTarget(index, "target_amount", event.target.value);
          }}
        />
      </Grid>
      {!disabled && (
        <Grid>
          <IconButton color="error" onClick={() => handleRemoveRow(index)}>
            <DeleteForeverIcon></DeleteForeverIcon>
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
}
